/* Just Catnip — tabbed reviews behaviour (PDP + homepage). Extracted from
   jc-product.js; dataset.ready guards keep double-loading harmless. */
(function () {
  /* one panel per tab (24 Sep 2026: per-instance tab sets); ARIA tabs pattern with
     roving tabindex, arrow/Home/End keys, and the theme editor jumping to the tab
     that holds a selected Tab or Review block */
  function initReviewTabs(section) {
    var tabs = section.querySelector('[data-review-tabs]');
    if (!tabs || tabs.dataset.ready) return;
    tabs.dataset.ready = '1';
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-tab]'));
    function select(b, focus) {
      buttons.forEach(function (x) {
        var on = x === b;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var panel = section.querySelector('[data-panel="' + x.getAttribute('data-tab') + '"]');
        if (panel) panel.hidden = !on;
      });
      if (focus) b.focus({ preventScroll: true });
      /* phones: the pill strip scrolls sideways; bring the selected pill to its centre */
      if (tabs.scrollWidth > tabs.clientWidth) {
        var tr = tabs.getBoundingClientRect(), br = b.getBoundingClientRect();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        tabs.scrollTo({ left: tabs.scrollLeft + (br.left - tr.left) - (tr.width - br.width) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]');
      if (b) select(b);
    });
    tabs.addEventListener('keydown', function (e) {
      var i = buttons.indexOf(document.activeElement);
      if (i < 0) return;
      var next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: buttons.length - 1 }[e.key];
      if (next === undefined) return;
      e.preventDefault();
      select(buttons[(next + buttons.length) % buttons.length], true);
    });
    section.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      var tab = el.closest('[data-tab]');
      var panel = el.closest('[data-panel]');
      var id = tab ? tab.getAttribute('data-tab') : panel ? panel.getAttribute('data-panel') : null;
      var b = id && tabs.querySelector('[data-tab="' + id + '"]');
      if (b) select(b);
    });
  }

  /* video tiles: play the Shopify-hosted video in place when one exists */
  function initVideoTiles(section) {
    section.querySelectorAll('[data-video-tile]').forEach(function (tile) {
      var video = tile.querySelector('video');
      if (!video || tile.dataset.ready) return;
      tile.dataset.ready = '1';
      tile.addEventListener('click', function () {
        tile.classList.add('playing');
        video.play();
      });
    });
  }

  function init() {
    document.querySelectorAll('.jc-reviews-tabbed').forEach(function (s) { initReviewTabs(s); initVideoTiles(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
